import { render, staticRenderFns } from "./new-template.vue?vue&type=template&id=2b6b06eb&scoped=true"
import script from "./new-template.vue?vue&type=script&lang=js"
export * from "./new-template.vue?vue&type=script&lang=js"
import style0 from "./new-template.vue?vue&type=style&index=0&id=2b6b06eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b06eb",
  null
  
)

export default component.exports